<div class='error-message-container'>
    <div class='error-message-container__header-message'>
        {{errorMessageModel.headerMessage}}
    </div>
    <div class='error-message-container__body-message'>
        {{errorMessageModel.bodyMessage}}
    </div>
</div>